module.exports = "/assets/4209d98c7d4bf577d3efc8e1fe2837f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/9F.png
// module id = 1158
// module chunks = 0